const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'] as const

/** Human-readable byte size, e.g. 1536 -> "1.5 KB". */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes <= 0) return '0 B'

  const index = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), UNITS.length - 1)
  const value = bytes / 1024 ** index
  const digits = UNITS[index] === 'B' ? 0 : 1

  return `${value.toFixed(digits)} ${UNITS[index]}`
}

/** Savings ratio as percentage string, e.g. 0.62 -> "62%". */
export function formatPercent(ratio: number): string {
  const clamped = Math.min(100, Math.max(0, Math.round(ratio * 100)))
  return `${clamped}%`
}

/** Swap a file name's extension, preserving its stem, e.g. clip.mov -> clip.webm. */
export function replaceExtension(name: string, extension: string): string {
  const stem = name.replace(/\.[^.]+$/, '')
  return `${stem}.${extension}`
}
